<mat-card class="page" *ngFor="let page of pages | async | sort:['title']">
  <h3>{{page.title}}</h3>
  <p>{{page.body | truncate: 20 }}</p>
</mat-card>
